/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type KiteAddressDetailInfo = {
    ADDR: string;
    ADDRT: KiteAddressDetailInfo.ADDRT;
    NM: string;
    BL: string;
    BLP: string;
    TKNCNT: string;
    FTRXUT: number;
    LTRXUT: number;
    CCADDR: string;
    CTRXHA: string;
};

export namespace KiteAddressDetailInfo {

    export enum ADDRT {
        EOA = 'EOA',
        CA = 'CA',
    }


}

